export default {
  defaultBulletinFilter: {
    fieldNameOrder: "creationDate",
    orderType: "DESC"
  },

  defaultPublishBulletinFilter: {
    fieldNameOrder: "publishDate",
    orderType: "DESC"
  },

  defaultScheduledPublishBulletinFilter: {
    fieldNameOrder: "publishDate",
    orderType: "DESC"
  },

  defaultRetireBulletinFilter: {
    fieldNameOrder: "retireDate",
    orderType: "DESC"
  },

  defaultArgumentFilter: {
    fieldNameOrder: "name",
    orderType: "ASC"
  }
};
